import { setForce, setGetForceFromPen } from '../actions';
import getPosition, { isTouchScreenDevice } from '../helpers/getPosition';
import styles from './Force.module.scss';

class Force {
  constructor(state, parent) {
    this.state = state;
    this.parent = parent;

    this.value = state.painting.force;
    this.isActive = !state.painting.getForceFromPen;

    this.createDOM();

    this.addEventListeners();

    this.updatePercentage();
  }

  createDOM() {
    this.container = document.createElement('div');
    this.container.className = styles.force;

    this.range = document.createElement('div');
    this.range.className = styles.range;
    this.container.appendChild(this.range);

    this.handler = document.createElement('div');
    this.handler.className = styles.handler;
    this.range.appendChild(this.handler);

    this.button = document.createElement('div');
    this.button.className = styles.button;
    this.container.appendChild(this.button);

    this.parent.appendChild(this.container);
  }

  addEventListeners() {
    this.changeType = this.changeType.bind(this);
    this.changeValue = this.changeValue.bind(this);

    if (isTouchScreenDevice) {
      this.range.addEventListener('touchstart', this.changeValue, false);
    } else {
      this.range.addEventListener('click', this.changeValue, false);
    }

    this.button.addEventListener('click', this.changeType, false);
  }

  changeValue(e) {
    e.preventDefault();
    e.stopPropagation();

    const clickPosition = getPosition(e);

    if (!clickPosition[2]) {
      return;
    }

    //  calculate delta of clicked element and click
    const bbox = this.range.getBoundingClientRect();
    const bottom = bbox.top + bbox.height;

    const value = Math.min(Math.max(0, (-clickPosition[1] + bottom) / bbox.height), 1);

    if (this.isActive) {
      setForce(value);
    }
  }

  changeType(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.isActive) {
      setGetForceFromPen(true);
    } else {
      setGetForceFromPen(false);
    }
  }

  updatePercentage() {
    this.handler.style.height = `${this.value * 100}%`;

    let color;

    if (this.isActive) {
      // color = this.state.measures.colors[this.state.controlling.buckets[this.state.controlling.selectedBucket]].color;
      color = '#919191';
      this.button.classList.add(styles.active);
    } else {
      color = 'rgba(255, 255, 255, 0.2)';
      this.button.classList.remove(styles.active);
    }

    this.handler.style.background = color;
  }

  update(state) {
    this.value = state.painting.force;
    this.isActive = !state.painting.getForceFromPen;

    this.state = state;

    this.updatePercentage();
  }

  alwaysUpdate(value) {
    if (!this.isActive) {
      this.value = value;

      this.updatePercentage();
    }
  }
}

export default Force;
